// Interfaces
import { PropsWithChildren, FC } from "react";

const ApplicationSocials: FC<PropsWithChildren> = ({ children }) => {
  return <div className="applications__socials">{children}</div>;
};

export default ApplicationSocials;
